import React from "react";
import { PalletStatus } from "../../../types/palletStatus";
import { PalletDetail } from "../../../types/palletDetail";

// this class show warning message if pallets are blocked for resorting or QI
// this is because US doesn't want resort pallets being unblocked or set different status
// and Dongen doesn't want QI pallets being unblocked or set different status
// the logic handling this exists in database procedure

type ModalDefects2BlockedStatusWarningProps = {
    isUsSite: boolean;
    siteId: number;
    pallets: PalletDetail[];
};

const ModalDefects2BlockedStatusWarning: React.FC<ModalDefects2BlockedStatusWarningProps> = ({ isUsSite, siteId, pallets }) => {
    const statuses = Array.from(new Set(pallets.map((p: PalletDetail) => p.originalStatusId)));
  
    if (isUsSite && statuses.includes(PalletStatus.BlockedResort))
        return (
            <div className="alert alert-warning" role="alert">
                Warning: Some pallets are blocked for resorting and cannot be changed.
                {/* <strong>Warning!</strong> Blocked Resort status cannot be changed */}
            </div>
        );
    if (siteId === 6 && statuses.includes(PalletStatus.BlockedQi))
        return (
            <div className="alert alert-warning" role="alert">
                Warning: Some pallets are blocked for QI and cannot be changed.
                {/* <strong>Warning!</strong> Blocked QI status cannot be changed */}
            </div>
        );
    return null;
};

export default ModalDefects2BlockedStatusWarning;
